import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.timelineData`;
export const INIT = `${SCOPE}/INIT`;
export const GET_TIMELINE_DATA = `${SCOPE}/GET_TIMELINE_DATA`;
